import PreparePlan from '~/pages/onboarding/preparePlan/libs/components/PreparePlan'
import { TPageProps } from '~/shared/types/commonTypes'

const PreparePlanBiology = ({ nextPagePath, pageId }: TPageProps) => (
  <PreparePlan nextPagePath={nextPagePath} pageId={pageId} />
)

export default PreparePlanBiology
